<template>
  <div class="hero">
    <div class="title">
      <p v-html="eng" :class="color"></p>
      <h1 v-html="title"></h1>
    </div>
    <div class="bread">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hero{
  position: relative;
  padding: var(--head) 0 0;
  border-bottom: module.$border 1px solid;
}
.title{
  color: module.$normal;
  padding: 3.6rem module.side2x() 8.8rem;
  @include module.flex();
  align-items: flex-end;
  justify-content: flex-start;
  gap: 2rem;
  line-height: 1;
  p{
    font-size: 4.8rem;
    font-weight: 700;
    color: module.$main;
    &.blue{
      color: module.$blue;
    }
    &.orange{
      color: module.$orange;
    }
  }
  h1{
    font-size: 1.4rem;
    font-weight: 700;
    transform: translateY(-.64rem);
  }
}
.bread{
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    eng: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
    color: {
      default: 'red'
    }
  }
}
</script>
